var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrowave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "microwave_svg__a",
  d: "M0 19.4h29.1V0H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 10)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M28.5 17.8c0 .6-.5 1.1-1.1 1.1H1.6c-.6 0-1.1-.5-1.1-1.1V1.6C.5 1 1 .5 1.6.5h25.9c.6 0 1.1.5 1.1 1.1v16.2zM2.8 10h18.6"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M25 3.9a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6ZM25 8.2a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6ZM5.9 5h13.2"
}), /*#__PURE__*/React.createElement("mask", {
  id: "microwave_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#microwave_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M2.9 16.7h18.7V3H2.9z",
  mask: "url(#microwave_svg__b)"
}))));
export default SvgMicrowave;